import IxeLogin from "../../pages/auth/ixe-login"
import NotFound from "../../pages/auth/NotFound"
import { RoleGuard } from "../guards"



export const LoginRoutes = () => {
    return (
        [
            { path: "", element: <RoleGuard roles={["customer"]}><IxeLogin /></RoleGuard> },  
			{ path: 'auth/notfound',element: <RoleGuard roles={["customer"]}><NotFound /></RoleGuard>},
			
                      
        ]
    )
}

            